const Layout = {
    backgroundColorV2: (props, contentConfig) => {
        let backgroundColor = props.backgroundColor;
        if (props.onBackgroundColor) {
            backgroundColor = props.onBackgroundColor();
        } else {
            let _contentConfig = contentConfig;
            if (_contentConfig && _contentConfig.desktop && _contentConfig.desktop.page) {
                _contentConfig = _contentConfig.desktop.page;
            }
            if (_contentConfig && _contentConfig.config) {
                if (_contentConfig.config.block && _contentConfig.config.block.backgroundColor) {
                    backgroundColor = _contentConfig.config.block.backgroundColor;
                } else if (_contentConfig.config.layout && _contentConfig.config.layout.backgroundColor) {
                    backgroundColor = _contentConfig.config.layout.backgroundColor;
                } else if (_contentConfig.config.layoutContent && _contentConfig.config.layoutContent.backgroundColor) {
                    backgroundColor = _contentConfig.config.layoutContent.backgroundColor;
                }
            }
        }
        return backgroundColor;
    },
    columns: function (data, columnCount) {
        const columns = [];
        for (let i = 0; i < columnCount; i++) {
            columns.push([]);
        }
        const _data = data || [];
        _data.forEach(function (d, i) {
            d.index = i;
            const columnIndex = i % columnCount;
            columns[columnIndex].push(d);
        });
        return columns;
    },
    columnSize: function (columnCount) {
        let size = '12';
        if (columnCount > 1) {
            size = (12 / columnCount).toString().replace('.', '_');
        }
        return size;
    },
    columnSpacing: function (index, columnCount, columnSpacing) {
        if (parseInt(columnCount, 10) > 1 && columnSpacing && columnSpacing.value && columnSpacing.unit) {
            const spacingFraction = parseFloat(columnSpacing.value / columnCount);
            const modulo = index % columnCount;
            return {
                left: `${parseFloat(modulo * spacingFraction)}${columnSpacing.unit}`,
                right: `${parseFloat((columnCount - modulo - 1) * spacingFraction)}${columnSpacing.unit}`
            };
        }
    },
    editorTextInternals: (text) => {
        if (!text) {
            return;
        }
        let index = text.indexOf('<p')
        if (index >= 0) {
            index = text.indexOf('>', index);
            if (index > 0) {
                return text.substring(index + 1).replace('</p>', '');
            }
        }
        return text;
    },
    hasTypedPage: function (config, type) {
        if (!config || !config.pages) {
            return false;
        }
        let page;
        for (let i = 0; i < config.pages.length; i++) {
            page = config.pages[i];
            if (!page.type || page.type.value != type) {
                continue;
            }
            return true;
        }
        return false;
    },
    isFrancisco: function (config) {
        return config != undefined && config.layout != undefined && config.layout.toLowerCase() == Layout.Type.Theme.Francisco;
    },
    navPages: function (config, limit, excludeGroups) {
        let pages = [];
        if (!config || !config.pages) {
            return pages;
        }
        config.pages.forEach((d) => {
            if (!d.showInNavigation) {
                return;
            }
            if (excludeGroups && d.type && d.type.value == Layout.Type.Page.Group) {
                return;
            }
            pages.push(d);
        });
        if (!isNaN(limit) && limit < pages.length) {
            pages = pages.slice(0, limit);
        }
        return pages;
    },
    shouldUseLineSpacing: function (index, dataLength, columnCount) {
        if (columnCount == 1) {
            // Single column => All cells except the last one get line spacing
            return index < dataLength - 1;
        } else if (dataLength > columnCount) {
            // Cells will only need spacing if there is more than one row
            const remainder = dataLength % columnCount;
            if (remainder == 0) {
                // All rows full => All cells except those in the last row get line spacing
                return index < dataLength - columnCount;
            } else {
                // All cells in a full row get line spacing
                const fullColumns = Math.floor(dataLength / columnCount);
                return index < (fullColumns * columnCount);
            }
        }
        return false;
    },
    wrapTextForEditor: ({ tag = 'p', tagExtras, text, textExtras, token, wrapWithTag }) => {
        let wrappedText = `<span${textExtras ? ` ${textExtras}` : ''}${token ? ` token="${token}"` : ''} data-heading="${tag}">${text || ''}</span>`;
        if (wrapWithTag != false) {
            wrappedText = `<p class="${tag}"${tagExtras ? ` ${tagExtras}` : ''}>${wrappedText}</p>`
        }
        return wrappedText;
    },

    Font: {
        typedStrings: (config) => {
            if (!config) {
                return {};
            }
            let body = '';
            if (config.bodyFont && config.bodyFont.family) {
                body = config.bodyFont.family;
            }
            let header = '';
            if (config.headerFont && config.headerFont.family) {
                header = config.headerFont.family;
            }
            if (config.fonts && config.fonts.families) {
                const createFontString = (d) => {
                    let fontString = `'${d.family}'`;
                    switch (d.category) {
                        case 'cursive':
                        case 'display':
                        case 'handwriting':
                            fontString += ',cursive';
                            break;
                        case 'sans-serif':
                        case 'serif':
                            fontString += `,${d.category}`;
                            break;
                    }
                    return fontString;
                }
                config.fonts.families.forEach((d) => {
                    switch (d.type) {
                        case 'Body':
                            body = createFontString(d);
                            break;
                        case 'Header':
                            header = createFontString(d);
                            break;
                    }
                });
            }
            return { body, header };
        }
    },

    Type: {
        Page: {
            Custom: 0,
            Portfolio: 1,
            Artists: 2,
            Exhibitions: 3,
            Press: 4,
            Contact: 5,
            ExternalLink: 6,
            Home: 7,
            Group: 8
        },
        Result: {
            HorizontalMasonry: 'masonry',
            List: 'list',
            Pinterest: 'waterfall',
            Slideshow: 'slideshow',
            Thumbnails: 'grid'
        },
        Theme: {
            Arizona: 'arizona',
            Classic: 'classic',
            Francisco: 'francisco',
            Mariana: 'mariana',
            Nashville: 'nashville',
            Novara: 'novara',
            Piedmont: 'piedmont',
            Sydney: 'sydney'
        }
    }
}
export default Layout;